import { axiosAuth } from "@/lib/axios";

import type { AuthUser } from "../types";

export const getUser = ({ userId }: { userId: string }): Promise<AuthUser> => {
  return axiosAuth.get(`me/${userId}`).then((response) => {
    return response.data.data;
  });
};
